exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-wrapper[data-v-78c3ce05]{background-color:hsla(0,0%,100%,.7);position:fixed;width:100%;height:100%;z-index:5000;top:0;text-align:center}.loading-wrapper img[data-v-78c3ce05]{position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.fade-enter-active[data-v-78c3ce05]{-webkit-transition:opacity 0s;transition:opacity 0s}.fade-enter[data-v-78c3ce05]{opacity:0}.fade-leave-active[data-v-78c3ce05]{-webkit-transition:opacity .2s;transition:opacity .2s}.fade-leave-to[data-v-78c3ce05]{opacity:.99}", ""]);

// exports
